/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {platformBrowser} from '@angular/platform-browser';
import {AllCommunityModule, ModuleRegistry} from 'ag-grid-community';

import {AppModule} from './app/app.module';
import {datadogLogs} from '@datadog/browser-logs';
import {environment} from './environments/environment';

// Register AG Grid modules (required for AG Grid 33.x+)
ModuleRegistry.registerModules([AllCommunityModule]);

datadogLogs.init({
  clientToken: environment.datadog.clientToken,
  version: environment.version,
  env: environment.datadog.env,
  service: environment.datadog.serviceName,
  site: environment.datadog.site,
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
});

platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err) => datadogLogs.logger.error(err));
